import { render, staticRenderFns } from "./PersonalContact.html?vue&type=template&id=49c8dc29&scoped=true&"
import script from "./PersonalContact.js?vue&type=script&lang=js&"
export * from "./PersonalContact.js?vue&type=script&lang=js&"
import style0 from "./PersonalContact.scss?vue&type=style&index=0&id=49c8dc29&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c8dc29",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VDivider,VIcon,VRow})
